export const DateFormat = 'dd/MM/yyyy';
export const DateTimeFormat = 'dd/MM/yyyy HH:mm';
export const DateTimeSecFormat = 'dd/MM/yyyy HH:mm:ss';